/**
 * Global JS
 */

// CSS
import styles from '../scss/index.scss';

// Vendors
import $ from 'jquery';
import 'fancybox/dist/js/jquery.fancybox.pack';
import 'jquery.maskedinput/src/jquery.maskedinput';
import './lib/wl-share';
import AOS from 'aos';

// Framework
import carousels from './framework/carousel';
import code from './framework/code';
import dropdowns from './framework/dropdown';
import modals from './framework/modal';
import notices from './framework/notice';
import tabs from './framework/tabs';
import toggles from './framework/toggle';
import tooltips from './framework/tooltip';
import utilities from './framework/utilities';

// Site modules
import './site/back-to-top';
import './site/header';
import './site/media-carousel';
import './site/timeline';
import './site/parallax';
import './site/navigation.js';
import './site/nav-mobile';
import './site/tabbed-media-carousel';
import './site/overlay.js';
import VideoModal from './site/video-modal';
import './lib/polyfils';
import './site/search.js';
import './site/loan-rates';

// Helpers
import { linkOutAlert, openPopUpWindow } from './lib/helpers';

$(document).on('click', 'a', linkOutAlert);

AOS.init({
  duration: 1000,
  once: true,
});

// Apply input masks
$('.mask-input-phone').mask('(999) 999-9999');
$('.mask-input-date').mask('99/99/9999');

// Init Fancybox
$('.fancybox').fancybox({
  helpers: {
    overlay: {
      locked: false, // Prevent page from jumping back to top
    },
  },
});

// Init Video Modal
const videoModalInstance = new VideoModal();
videoModalInstance.init();

// Init single carousel
const carouselSingle = carousels('[data-carousel="single"]', {
  autoplay: true,
  autoplaySpeed: 4000,
  speed: 800,
  dots: true,
  infinite: true,
});

// Init multiple carousel
const carouselMultiple = carousels('[data-carousel="multiple"]', {
  autoplay: false,
  dots: true,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

// Init modals
modals('[data-modal]');

// Init toggles
toggles('[data-toggle-target]');

// Init notices
notices('[data-notice-dismissible]');

// Init tabs
tabs();

// Init code
code('[data-code]');

// Init tooltips
tooltips('[data-tooltip]');

// Init dropdowns
dropdowns('[data-dropdown]');

$('.wl-live-chat a').attr({
  title: 'View: Talk to our team',
  ['data-action-popup']: ''
});

// Init openPopUpWindow function
$('[data-action-popup]').click(event => {
  event.preventDefault();
  openPopUpWindow(event.currentTarget.href);
});

// online banking log in code
// desktop-login-form
function preLogonRequest(userName) {
  var form = document.querySelector("#Q2OnlineLogin");
  var url = new URL(form);
  var uuxPath = url.pathname.substring(0, url.pathname.lastIndexOf('/')) + "/";
  var uuxDomain = url.origin;
  var xmlhttp = new XMLHttpRequest();
  xmlhttp.open("POST", uuxDomain + uuxPath + "mobilews/preLogonUser");
  xmlhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
  xmlhttp.send(JSON.stringify({ userId: userName }));
}

document.querySelector('#user_id').addEventListener('blur', function(event) {
  var userName = event.target.value;
  preLogonRequest(userName);
  document.cookie = "lastUserName=" + userName + "||";
});

function getCookie(name) {
   var start = document.cookie.indexOf(name);
   var end = document.cookie.indexOf("||", start);
   if (start === -1 || end === -1 || !name) { return null; }
   return document.cookie.substring(start + name.length + 1, end);
}

var lastUserName = getCookie('lastUserName');

if (lastUserName) {
  preLogonRequest(lastUserName);
}

// Fixes the wonkyness of the Engageware FAQ widget
(() => {
  const HEADER_SELECTOR = '.site-header';
  const FALLBACK_OFFSET = 200;

  function getOffset() {
    const header = document.querySelector(HEADER_SELECTOR);
    return header ? Math.ceil(header.getBoundingClientRect().height + 50) : FALLBACK_OFFSET;
  }

  const bound = new WeakSet();
  function bindButton(btn) {
    if (!btn || bound.has(btn)) return;
    bound.add(btn);

    btn.addEventListener('click', () => {
      // Let the widget do its snap first
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const offset = getOffset();
          // Nudge viewport down so the snapped target sits below header
          window.scrollTo(0, window.scrollY - offset);
        });
      });
    }, { passive: true });
  }

  // Initial pass (in case buttons already exist)
  document.querySelectorAll('.sc-result-item.answer').forEach(bindButton);

  // Observe the FAQ card area (or whole document) for dynamically inserted buttons
  const container =
    document.querySelector('.card.card--faq-widget') || document.body;

  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      // Check added nodes and their descendants for buttons
      m.addedNodes && m.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        if (node.matches && node.matches('.sc-result-item.answer')) {
          bindButton(node);
        }
        node.querySelectorAll && node.querySelectorAll('.sc-result-item.answer').forEach(bindButton);
      });
    }
  });

  obs.observe(container, { childList: true, subtree: true });
})();

// Reusable: works for any .password-toggle paired via aria-controls
(function initPasswordTogglesFA4() {
  document.querySelectorAll('.password-toggle').forEach((btn) => {
    const input = document.getElementById(btn.getAttribute('aria-controls'));
    const icon  = btn.querySelector('i');
    if (!input || !icon) return;

    btn.addEventListener('click', () => {
      const showing = input.type === 'text';
      input.type = showing ? 'password' : 'text';
      const nowShowing = !showing;

      icon.classList.toggle('fa-eye', !nowShowing);
      icon.classList.toggle('fa-eye-slash', nowShowing);

      btn.setAttribute('aria-pressed', String(nowShowing));
      btn.setAttribute('aria-label', nowShowing ? 'Hide password' : 'Show password');
      input.focus({ preventScroll: true });
    });
  });
})();
